import $ from 'jquery';

export default () => {
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function(){
    const width  = $(this).attr('width');
    $(this).wrap( '<div class="iframe-wrap" style="max-width: ' + (width ? (width+"px") : "100%" )+'"><div class="flex-video widescreen"></div></div>' )
    // $(this).wrap( '<div class="iframe-wrap"><div class="flex-video widescreen"></div></div>' )
  });
}